/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KnownTimeMapping } from './KnownTimeMapping';
import {
    KnownTimeMappingFromJSON,
    KnownTimeMappingFromJSONTyped,
    KnownTimeMappingToJSON,
    KnownTimeMappingToJSONTyped,
} from './KnownTimeMapping';

/**
 * 
 * @export
 * @interface CorrectRunClockRequest
 */
export interface CorrectRunClockRequest {
    /**
     * 
     */
    runId: string;
    /**
     * 
     */
    deltaSeconds?: number | null;
    /**
     * 
     */
    known?: KnownTimeMapping | null;
}

/**
 * Check if a given object implements the CorrectRunClockRequest interface.
 */
export function instanceOfCorrectRunClockRequest(value: object): value is CorrectRunClockRequest {
    if ((!('runId' in (value as Record<string, any>)) && !('run_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['runId'] === undefined && (value as Record<string, any>)['run_id'] === undefined)) return false;
    return true;
}

export function CorrectRunClockRequestFromJSON(json: any): CorrectRunClockRequest {
    return CorrectRunClockRequestFromJSONTyped(json, false);
}

export function CorrectRunClockRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectRunClockRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'runId': json['run_id'],
        'deltaSeconds': json['delta_seconds'] === undefined ? undefined : json['delta_seconds'] === null ? null : json['delta_seconds'],
        'known': json['known'] === undefined ? undefined : json['known'] === null ? null : KnownTimeMappingFromJSON(json['known']),
    };
}

export function CorrectRunClockRequestToJSON(json: any): CorrectRunClockRequest {
    return CorrectRunClockRequestToJSONTyped(json, false);
}

export function CorrectRunClockRequestToJSONTyped(value?: CorrectRunClockRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'run_id': value['runId'],
        'delta_seconds': value['deltaSeconds'],
        'known': KnownTimeMappingToJSON(value['known']),
    };
}

